import React from 'react'
import { Text } from '@maui/elements'

export const RequiredIndicator = () => {
  return (
    <Text display="inline-block" color="colorFeedbackError">
      *
    </Text>
  )
}
